module.exports = __webpack_public_path__ + "static/media/blackCrossIcon.f8d571e9.svg";